import { memo } from 'react'

import Counter, { CounterProps } from '../counter'
import { GuestType } from '../../search-result-listing/header-section/types'

const GuestCounter = memo<CounterProps<GuestType>>(Counter)

export default GuestCounter
